import { FeedbackPromptResponseDetails } from "./EmployeeFeedbackModel";
//BuddyFeedbackDOJA45D  Prompt -> On submission records get pushed to Strand.
export class BuddyFeedbackDOJA45DModel {
    EnterpriseId!: string;
    CardUniqueId!: string;
    FeedbackPromptComments!:string[];
    CategoryType!: string;
    ChannelType!: string;
    FeedbackPromptResponseDetails !: FeedbackPromptResponseDetails[];
    IsPostAnonymous !: boolean;
}